// extracted by mini-css-extract-plugin
export var businessTypes = "footer-module--businessTypes--4cb8d";
export var capitalize = "footer-module--capitalize--46bf5";
export var category = "footer-module--category--c516c";
export var categoryTitle = "footer-module--categoryTitle--65a2a";
export var features = "footer-module--features--a6ed0";
export var footer = "footer-module--footer--ac64d";
export var footerBg = "footer-module--footerBg--5908b";
export var footerContent = "footer-module--footerContent--832ff";
export var legal = "footer-module--legal--81d0b";
export var legalLinks = "footer-module--legalLinks--5e9cd";
export var logo = "footer-module--logo--62dd1";
export var platform = "footer-module--platform--ed758";
export var resources = "footer-module--resources--6d44f";
export var social = "footer-module--social--64f0e";
export var wrapper = "footer-module--wrapper--3bfde";